
{
  "familyId": "GET-PROC-AFNAME",
  "questions": [
    {
      "id": "GET-PROC-AFNAME-001",
      "familyId": "GET-PROC-AFNAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_afname",
      "questionType": "multiple_choice",
      "question": "Een winkelmanager verlaagt de prijs van een laptop van €800 met 20% korting. Wat betaalt de klant?",
      "options": [
        "€640",
        "€780",
        "€600",
        "€160"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 20,
            "label": "20% korting op €800 → €160 eraf, €640 te betalen",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 20% korting" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Korting berekenen",
            "content": "Bereken eerst de korting: 20% van €800 = 0,20 × 800 = €160. Trek dan af: €800 − €160 = €640. Of sneller: vermenigvuldig met (100% − 20%) = 80% = 0,80. €800 × 0,80 = €640.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_afname_korting",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 3
      },
      "feedback": {
        "explanationText": "20% van €800 = 0,20 × 800 = €160 korting. De klant betaalt: €800 − €160 = €640. Je kunt ook direct rekenen: €800 × 0,80 = €640.",
        "solutionSteps": [
          "Bereken de korting: 20% van €800 = 0,20 × 800 = €160",
          "Trek de korting af: €800 − €160 = €640",
          "Of direct: €800 × 0,80 = €640"
        ],
        "distractorExplanations": {
          "0": "Goed! 20% van 800 = 160. De klant betaalt: 800 − 160 = €640.",
          "1": "Je dacht waarschijnlijk dat je 20 moest aftrekken in plaats van 20%. Maar 20% van 800 = 160, niet 20. Onthoud: procent betekent 'per honderd', dus 20% = 0,20 × het bedrag.",
          "2": "Je dacht waarschijnlijk dat de korting 25% was. 25% van 800 = 200, en 800 − 200 = 600. Maar de korting is 20%, niet 25%. Onthoud: reken altijd met het percentage dat in de opgave staat.",
          "3": "Je dacht waarschijnlijk dat €160 het antwoord was. Maar €160 is de korting, niet wat de klant betaalt. Onthoud: bij korting trek je het kortingsbedrag af van de oorspronkelijke prijs."
        }
      }
    },
    {
      "id": "GET-PROC-AFNAME-002",
      "familyId": "GET-PROC-AFNAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_afname",
      "questionType": "multiple_choice",
      "question": "Een financieel adviseur berekent de afname-factor bij 30% waardedaling. Met welke factor vermenigvuldig je?",
      "options": [
        "0,70",
        "0,30",
        "1,30",
        "0,07"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 30,
            "label": "30% afname → 70% blijft → factor 0,70",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 30% afname, 70% blijft" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afname-factor berekenen",
            "content": "Bij een afname trek je het percentage af van 100%. De afname-factor = 1 − percentage als decimaal. Dus bij 30% afname: factor = 1 − 0,30 = 0,70.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_afname_factor",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Bij een afname van 30% houd je 100% − 30% = 70% over. Als decimaal: 70% = 0,70. De afname-factor is dus 0,70.",
        "solutionSteps": [
          "Schrijf het percentage als decimaal: 30% = 0,30",
          "Trek af van 1: factor = 1 − 0,30 = 0,70",
          "Check: 0,70 = 70% — je houdt 70% over na 30% afname ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Afname van 30% → factor = 1 − 0,30 = 0,70.",
          "1": "Je dacht waarschijnlijk dat het percentage zelf de factor is. Maar 0,30 is de afname, niet de factor waarmee je vermenigvuldigt. Onthoud: de afname-factor = 1 − het percentage als decimaal, dus 1 − 0,30 = 0,70.",
          "2": "Je dacht waarschijnlijk dat je het percentage moet optellen bij 1. Maar 1 + 0,30 = 1,30 is een toename-factor (30% erbij), niet een afname-factor. Onthoud: bij afname trek je af, bij toename tel je op.",
          "3": "Je dacht waarschijnlijk dat 30% = 0,03. Maar 30% = 0,30 (deel door 100, niet door 1000). Onthoud: om procenten om te zetten naar decimalen, deel je door 100."
        }
      }
    },
    {
      "id": "GET-PROC-AFNAME-003",
      "familyId": "GET-PROC-AFNAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_afname",
      "questionType": "multiple_choice",
      "question": "Een autohandelaar taxeert een auto op €15.000. Na een jaar is de waarde met 12% gedaald. Wat is de auto nu waard?",
      "options": [
        "€13.200",
        "€13.800",
        "€3.000",
        "€16.800"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 12,
            "label": "12% waardedaling op €15.000 → €1.800 eraf, €13.200 over",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 12% waardedaling" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Waardedaling berekenen",
            "content": "Bereken de daling: 12% van €15.000 = 0,12 × 15.000 = €1.800. Trek af: €15.000 − €1.800 = €13.200. Of direct: €15.000 × 0,88 = €13.200.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_afname_waardedaling",
      "variantIndex": 3,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 3
      },
      "feedback": {
        "explanationText": "12% van €15.000 = 0,12 × 15.000 = €1.800 waardedaling. Nieuwe waarde: €15.000 − €1.800 = €13.200. Je kunt ook direct rekenen: €15.000 × 0,88 = €13.200.",
        "solutionSteps": [
          "Bereken de daling: 12% van €15.000 = 0,12 × 15.000 = €1.800",
          "Trek af van de oorspronkelijke waarde: €15.000 − €1.800 = €13.200",
          "Check: €13.200 ÷ €15.000 = 0,88 = 88% → 12% minder ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 12% van 15.000 = 1.800. Nieuwe waarde: 15.000 − 1.800 = €13.200.",
          "1": "Je dacht waarschijnlijk dat de daling 8% was in plaats van 12%. 8% van 15.000 = 1.200, en 15.000 − 1.200 = 13.800. Maar de daling is 12%. Onthoud: reken altijd met het percentage uit de opgave.",
          "2": "Je dacht waarschijnlijk dat de daling 20% was. 20% van 15.000 = 3.000. Maar €3.000 is niet de nieuwe waarde — het zou de daling zijn bij 20%. Onthoud: de nieuwe waarde = oorspronkelijk − daling.",
          "3": "Je dacht waarschijnlijk dat je de daling moest optellen. Maar bij waardedaling trek je af, niet op. Onthoud: daling = aftrekken, stijging = optellen. €15.000 − €1.800 = €13.200."
        }
      }
    },
    {
      "id": "GET-PROC-AFNAME-004",
      "familyId": "GET-PROC-AFNAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_afname",
      "questionType": "multiple_choice",
      "question": "Een kledingverkoper zet alle prijzen 35% af tijdens de uitverkoop. Een jas kostte €80. Wat is de nieuwe prijs?",
      "options": [
        "€52",
        "€45",
        "€28",
        "€108"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 35,
            "label": "35% korting op €80 → €28 eraf, €52 te betalen",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 35% korting" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Uitverkoopprijs berekenen",
            "content": "Bereken de korting: 35% van €80 = 0,35 × 80 = €28. Trek af: €80 − €28 = €52. Of direct: €80 × 0,65 = €52.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_afname_uitverkoop",
      "variantIndex": 4,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 3
      },
      "feedback": {
        "explanationText": "35% van €80 = 0,35 × 80 = €28 korting. Nieuwe prijs: €80 − €28 = €52. Je kunt ook direct rekenen: €80 × 0,65 = €52.",
        "solutionSteps": [
          "Bereken de korting: 35% van €80 = 0,35 × 80 = €28",
          "Trek af: €80 − €28 = €52",
          "Of direct: €80 × (1 − 0,35) = €80 × 0,65 = €52"
        ],
        "distractorExplanations": {
          "0": "Goed! 35% van 80 = 28. Nieuwe prijs: 80 − 28 = €52.",
          "1": "Je dacht waarschijnlijk dat je 35 moest aftrekken van 80. Maar 35% van 80 = 28, niet 35. Onthoud: 35% ≠ €35. Je moet het percentage berekenen: 0,35 × 80 = 28.",
          "2": "Je dacht waarschijnlijk dat €28 de nieuwe prijs was. Maar €28 is de korting, niet wat de klant betaalt. Onthoud: nieuwe prijs = oude prijs − korting = €80 − €28 = €52.",
          "3": "Je dacht waarschijnlijk dat je de korting moest optellen. Maar bij korting trek je af: €80 − €28 = €52, niet €80 + €28 = €108. Onthoud: korting = aftrekken."
        }
      }
    },
    {
      "id": "GET-PROC-AFNAME-005",
      "familyId": "GET-PROC-AFNAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_afname",
      "questionType": "multiple_choice",
      "question": "Een inkoper bij een supermarkt koopt 500 kg appels in. Door bederf gaat 8% verloren. Hoeveel kilogram bruikbare appels blijft er over?",
      "options": [
        "460 kg",
        "492 kg",
        "40 kg",
        "540 kg"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 8,
            "label": "8% verlies op 500 kg → 40 kg weg, 460 kg over",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 8% verlies door bederf" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verlies door bederf berekenen",
            "content": "Bereken het verlies: 8% van 500 = 0,08 × 500 = 40 kg. Trek af: 500 − 40 = 460 kg. Of direct: 500 × 0,92 = 460 kg.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_afname_bederf_context",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 3
      },
      "feedback": {
        "explanationText": "8% van 500 kg = 0,08 × 500 = 40 kg gaat verloren door bederf. Er blijft over: 500 − 40 = 460 kg bruikbare appels.",
        "solutionSteps": [
          "Bereken het verlies: 8% van 500 = 0,08 × 500 = 40 kg",
          "Trek af: 500 − 40 = 460 kg",
          "Check: 460 ÷ 500 = 0,92 = 92% → 8% verloren ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 8% van 500 = 40 kg verlies. Over: 500 − 40 = 460 kg.",
          "1": "Je dacht waarschijnlijk dat je 8 moest aftrekken in plaats van 8%. Maar 8% van 500 = 40, niet 8. Onthoud: 8% ≠ 8. Je moet het percentage berekenen: 0,08 × 500 = 40.",
          "2": "Je dacht waarschijnlijk dat 40 kg het antwoord was. Maar 40 kg is het verlies, niet wat er overblijft. Onthoud: overblijvend = totaal − verlies = 500 − 40 = 460 kg.",
          "3": "Je dacht waarschijnlijk dat je het verlies moest optellen. Maar bij verlies trek je af: 500 − 40 = 460, niet 500 + 40 = 540. Onthoud: verlies en afname = aftrekken."
        }
      }
    }
  ]
}
